<template>
  <div />
</template>

<script>

export default {
  name: 'pacing-action',
  props: [
    'valueBool',
    'readonly',
    'emitter',
    'ikey',
    'getData',
    'putData',
    'control',
  ],
  data() {
    return {
      state: {
      },
    };
  },
  computed: {
  },
  created() {
  },
  mounted() {
    this.update();
  },
  methods: {
    update() {
      this.putData(this.ikey, {
        type: 'PACING',
        id: 'TRANSCUTANEOUS',
        valueBool: this.valueBool,
      });
      this.emitter.trigger('process', this.control);
    },
  },
};
</script>

<style>
</style>
